import Api from '@/api/api'

export default {
    getFacility() {
        // return Api.get('Org/facility/GetFacility')
         return Api.get('ETMSAgr/Facility/GetFacility')
    },
    getFacilityById(id) {
        return Api.get('Org/facility/GetFacilityById/' + id)
    },
    addFacility(data) {
        return Api.post('Org/facility/AddFacility', data)
    },
    updateFacility(id, data) {
        return Api.put('Org/facility/UpdateFacility/' + id, data)
    },
    deleteFacility(id) {
        return Api.delete('Org/facility/DeleteFacility/' + id)
    }
}